module.exports = __webpack_public_path__ + "img/bg_service.aa41ba4c.png";